const autoSetOptionItem = (optionList, name, changeDropdownValue) => {
  if (optionList.length === 1) {
    changeDropdownValue(name, optionList[0].value);
  }
};

export default autoSetOptionItem;
